<template>
  <Swiper
    class="month-slider h-36 min-h-36"
    v-bind="sliderOptions"
    :loading="loading"
    loading-skeleton-animation="skeleton-slides"
    hide-arrow-when-disabled
  >
    <DeparturesCalendarMonthSliderMonth
      v-for="month in months"
      :key="month.date"
      v-bind="month"
      :is-active="selectedYearMonth && month.date.startsWith(selectedYearMonth)"
      @click="onSelectYearMonth(month.date)"
    />
  </Swiper>
</template>

<script setup>
const props = defineProps({
  departures: {
    type: Array,
    default: () => [],
  },

  selectedYearMonth: {
    type: String,
    required: true,
  },

  loading: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['selectYearMonth'])

const dayjs = useDayjs()

const months = computed(
  () => Object.values(
    props.departures.reduce((bestPriceMonths, departure) => {
      const yearMonthDate = dayjs(departure[0].date).format('YYYY MM')

      if (
        !bestPriceMonths[yearMonthDate] ||
        bestPriceMonths[yearMonthDate].price > departure[0].price
      ) {
        return {
          ...bestPriceMonths,
          [yearMonthDate]: departure[0],
        }
      }

      return bestPriceMonths
    }, {})
  )
    .reduce((months, bestPriceMonth) => [
      ...months,
      ({
        price: bestPriceMonth.price,
        originalPrice: bestPriceMonth.original_price,
        date: bestPriceMonth.date,
      }),
    ], [])
    .sort((a, b) => a.date > b.date ? 1 : -1)
)

const sliderOptions = computed(() => ({
  arrowsAlign: 'inner-border',
  arrowsType: 'modern',
  swiperContainerStyle: 'padding: 0 0.4rem',
  constantDisplayNavigation: true,
  navigation: true,
  pagination: false,
  initialSlide: 0,
  spaceBetween: 10,
  slidesPerView: 3,
  breakpoints: {
    [getTailwindBreakpointsPx().md]: {
      slidesPerView: 5,
    },

    1366: {
      slidesPerView: 6,
    },

    [getTailwindBreakpointsPx()['2xl']]: {
      slidesPerView: 7,
    },
  },
}))

const onSelectYearMonth = (date) => {
  const yearMonth = dayjs(date).format('YYYY-MM')
  emit('selectYearMonth', yearMonth)
}
</script>